import type { ReactNode } from 'react'
import { cx } from './cx'

/**
 * Five roles, no more. The palette contract in CLAUDE.md maps every accent
 * family onto one of these — do not add a tone for a new colour, map the
 * colour onto an existing role.
 */
export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'accent'

const TONE: Record<BadgeTone, string> = {
  neutral: 'bg-gray-100 text-gray-600',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-red-100 text-red-700',
  accent: 'bg-brand-100 text-brand-700',
}

export default function Badge({
  tone = 'neutral',
  className,
  children,
}: {
  tone?: BadgeTone
  className?: string
  children: ReactNode
}) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
